module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'tour' && templateVars.config ?
				templateVars.config :
				{
	"ru": {
		"logo": {
			"id": "top_nav_logo",
			"steps": [
				{
					"target": "body:not(.body--main-page) .js-header-top-nav",
					"placement": "bottom",
					"width": 385,
					"fixedElement": true,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Нажмите на логотип для перехода на главную страницу сайта.\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 40px 20",
					"yOffset": -20
				}
			]
		},
		"buttonsPanelDownloadPdf": {
			"id": "buttonsPanelDownloadPdf",
			"steps": [
				{
					"target": "#buttons-panel-download-pdf",
					"placement": "bottom",
					"arrowOffset": "center",
					"fixedElement": true,
					"width": 385,
					"xOffset": -125,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Используйте эту кнопку, чтобы скачать PDF-версию отчета в удобном для вас формате (постранично или разворотами).\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 40px 20",
					"yOffset": -10,
					"buttonsPanelDownloadPdf": null
				}
			]
		},
		"mainpagePlayStopController": {
			"id": "mainpagePlayStopController",
			"steps": [
				{
					"target": "#mainpage-play-stop-controller",
					"placement": "bottom",
					"width": 385,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Используйте эту кнопку для начала просмотра или остановки прокрутки слайдов.\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 40px 20",
					"yOffset": -10
				}
			]
		},
		"mainapgeSliderProgressBar": {
			"id": "mainapgeSliderProgressBar",
			"steps": [
				{
					"target": "#mainapge-slider-progress-bar-inner",
					"placement": "top",
					"width": 385,
					"arrowOffset": "center",
					"xOffset": 347,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Используйте это меню для навигации по слайдам.\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 40px 20",
					"yOffset": 10
				}
			]
		},
		"buttonsPanelTools": {
			"id": "buttons_panel_tools",
			"steps": [
				{
					"target": "#buttons-panel-tools",
					"placement": "left",
					"width": 345,
					"fixedElement": true,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Используйте панель инструментов для работы с интерактивным отчетом.<br/>\n      Для переключения между страницами отчета воспользуйтесь навигацией.\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 20px 20",
					"yOffset": 0,
					"xOffset": 5
				}
			]
		},
		"interactiveMap": {
			"id": "interactive_map",
			"steps": [
				{
					"target": "#logistic-map-zoom-panel",
					"placement": "left",
					"width": 320,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Вы можете увеличить или уменьшить размер изображения.\n      </div>\n  </div>\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--drag\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Для движения по карте перемещайте мышь, удерживая левую кнопку.\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 20px 20",
					"yOffset": 0,
					"xOffset": 5
				}
			]
		}
	},
	"en": {
		"logo": {
			"id": "top_nav_logo",
			"steps": [
				{
					"target": "body:not(.body--main-page) .js-header-top-nav",
					"placement": "bottom",
					"width": 385,
					"fixedElement": true,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Click on the logo to go to the main page.\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 40px 20",
					"yOffset": -20
				}
			]
		},
		"buttonsPanelDownloadPdf": {
			"id": "buttonsPanelDownloadPdf",
			"steps": [
				{
					"target": "#buttons-panel-download-pdf",
					"placement": "bottom",
					"arrowOffset": "center",
					"width": 385,
					"fixedElement": true,
					"xOffset": -125,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Click this button to download the PDF version of the report in a format you need (in pages or spreads).\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 40px 20",
					"yOffset": -10,
					"buttonsPanelDownloadPdf": null
				}
			]
		},
		"mainpagePlayStopController": {
			"id": "mainpagePlayStopController",
			"steps": [
				{
					"target": "#mainpage-play-stop-controller",
					"placement": "bottom",
					"width": 385,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Use this button to start or pause the slideshow.\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 40px 20",
					"yOffset": -10
				}
			]
		},
		"mainapgeSliderProgressBar": {
			"id": "mainapgeSliderProgressBar",
			"steps": [
				{
					"target": "#mainapge-slider-progress-bar-inner",
					"placement": "top",
					"width": 385,
					"arrowOffset": "center",
					"xOffset": 347,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Use this menu to navigate through the slides.\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 40px 20",
					"yOffset": 10
				}
			]
		},
		"buttonsPanelTools": {
			"id": "buttons_panel_tools",
			"steps": [
				{
					"target": "#buttons-panel-tools",
					"placement": "left",
					"width": 345,
					"fixedElement": true,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Use the toolbar for work with the online report.<br/>\n      Use the navigation buttons to switch through the report pages.\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 20px 20",
					"yOffset": 0,
					"xOffset": 5
				}
			]
		},
		"interactiveMap": {
			"id": "interactive_map",
			"steps": [
				{
					"target": "#logistic-map-zoom-panel",
					"placement": "left",
					"width": 320,
					"title": "<div class=\"tooltip-block\">\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--click\"></div>\n    <div class=\"tooltip-block__section-content\">\n      Scale the map.\n      </div>\n  </div>\n  <div class=\"tooltip-block__section\">\n    <div class=\"tooltip-block__icon tooltip-block__icon--drag\"></div>\n    <div class=\"tooltip-block__section-content\">\n      You can zoom in or out on an image.<br/>\n      To move around the map move the mouse holding down the left button.\n    </div>\n  </div>\n</div>\n",
					"showNextButton": false,
					"showPrevButton": false,
					"padding": "40px 50px 20px 20",
					"yOffset": 0,
					"xOffset": 5
				}
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/tour/config.yaml
// module id = 91
// module chunks = 0